<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Xu3LWC/tc-custom/9781473815735.jpg?1703707474942" alt="This image is the cover for the book KGB's Poison Factory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">KGB's Poison Factory
      </h1>
      <p class="bookDescription body article font2">
        <b>“A cracking good read” and a chilling true story of Russia’s assassination program begun more than a century ago and which continues today (Tennent H. Bagley, former CIA chief of Soviet Bloc counterintelligence).</b><br/>  <br/> In late November 2006, Alexander Litvinenko—a former lieutenant colonel of the Federal Security Service of the Russian Federation—was ruthlessly assassinated in London by radiation poisoning. The shocking murder was the most notorious crime committed by the Russian intelligence on foreign soil in more than three decades.<br/>  <br/> Here, former Russian military intelligence officer and an international expert in special operations Boris Volodarsky—who was consulted by the Metropolitan Police during the Litvinenko investigation—offers readers a startling narrative of the Russian security services’ history of covert assassination by poisoning.<br/>  <br/> Beginning in 1917 with Lenin and his dreaded <i>Cheka</i> secret police, Russian security services have committed killing after killing both in Russia and across the globe. In <i>The KGB’s Poison Factory</i>, Volodarsky proves that the Litvinenko’s poisoning—supposedly ordered by Russian strongman Vladimir Putin—is just one episode in a chain of murders going back decades. Some of these assassinations or attempted assassinations are already known, others are revealed here for the first time.<br/>  <br/> With keen insight, Volodarsky brings readers inside the assassinations of twenty individuals killed by order of the Kremlin in a revealing tell-all that “will fascinate students as well as general readers interested in international espionage” (<i>Library Journal</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Boris Volodarsky
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a092394